import { applyMiddleware, compose, createStore } from 'redux'
import reduxThunk from 'redux-thunk'
import reducers from './reducers'
import { trackingMiddleware } from './middlewares/tracking'

const composeEnhancers =
  process.env.NODE_ENV !== 'production' &&
  typeof window !== 'undefined' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose

const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(reduxThunk, trackingMiddleware)),
)

export default store
